import type { ReactNode } from "react";

import { Card, CardContent, CardHeader } from "@/core/components/ui/card";
import { NoTranslate } from "@/core/components/ui/no-translate";
import { cn } from "@/core/utils/func/cn";

export type StatisticsCard01Props = {
  icon: ReactNode;
  value: string;
  title: string;
  changePercentage: string;
  comparisonLabel: string;
  className?: string;
};

export const StatisticsCard01 = ({
  icon,
  value,
  title,
  changePercentage,
  comparisonLabel,
  className,
}: StatisticsCard01Props) => {
  return (
    <Card className={cn("relative", className)}>
      <span
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-0 h-1 rounded-t-[20px] bg-gradient-accent"
      />
      <CardHeader className="flex flex-row items-center gap-2">
        <div className="flex size-8 shrink-0 items-center justify-center rounded-sm bg-accent/10 text-accent-dark dark:text-accent-light">
          {icon}
        </div>
        <NoTranslate as="span" className="text-2xl">
          {value}
        </NoTranslate>
      </CardHeader>
      <CardContent className="flex flex-col gap-2">
        <span className="text-base font-semibold">{title}</span>
        <p className="space-x-2">
          <NoTranslate as="span">{changePercentage}</NoTranslate>
          <span className="text-muted-foreground">{comparisonLabel}</span>
        </p>
      </CardContent>
    </Card>
  );
};
